import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '@victory-lib-ui/shared/data-access';
import { ApiResponse } from '@victory-lib-ui/shared/models';
import {
  DashboardOverviewResponse,
  DashboardRecentPassagesResponse,
  DashboardStatsResponse,
  DashboardVerseOfDayResponse,
} from './dashboard.models';

@Injectable({ providedIn: 'root' })
export class DashboardApiService extends BaseApiService {
  constructor() {
    super('dashboard');
  }

  getOverview(): Observable<ApiResponse<DashboardOverviewResponse>> {
    return this.get<ApiResponse<DashboardOverviewResponse>>('/overview');
  }

  getStats(): Observable<ApiResponse<DashboardStatsResponse>> {
    return this.get<ApiResponse<DashboardStatsResponse>>('/stats');
  }

  getRecentPassages(): Observable<
    ApiResponse<DashboardRecentPassagesResponse>
  > {
    return this.get<ApiResponse<DashboardRecentPassagesResponse>>(
      '/recent-passages'
    );
  }

  getVerseOfTheDay(
    locale?: string
  ): Observable<ApiResponse<DashboardVerseOfDayResponse>> {
    const params = locale ? { locale } : undefined;
    return this.get<ApiResponse<DashboardVerseOfDayResponse>>(
      '/verse-of-the-day',
      {
        params,
      }
    );
  }
}
